import { Editor, Range } from 'slate';

import { AlineTransforms, isDeleteEdit, Queries } from '../internal';
import type { CapitalizationStyle } from '../transforms/capitalization';
import { applyCapitalization, CAPITALIZATION_STYLES } from '../transforms/capitalization';

export const CAPITALIZATION_VOID_SEPARATOR = '\t';

export function getActiveCapitalizationStyle(text: string): CapitalizationStyle | undefined {
  if (!text) return undefined;
  return CAPITALIZATION_STYLES.find(style => applyCapitalization(text, style) === text);
}

const capitalizationQueries = {
  activeCapitalizationStyle: (editor: Editor): CapitalizationStyle | undefined => {
    const ranges = Queries.capitalizationRanges(editor);
    if (!ranges.length) return undefined;
    return getActiveCapitalizationStyle(
      ranges
        .map(at =>
          Queries.string(editor, {
            at,
            includeText: text => !text.suggestedEdits?.some(isDeleteEdit),
            paragraphSeparator: '\n',
            voidSeparator: CAPITALIZATION_VOID_SEPARATOR,
          })
        )
        .join('\n')
    );
  },

  capitalizationRanges: (editor: Editor): Range[] => {
    if (!editor.selection || editor.selection.listMarker) return [];

    const gridCellEntries = Queries.getGridSelectionCellEntries(editor);
    if (gridCellEntries)
      return gridCellEntries.map(([, cellPath]) => Editor.range(editor, cellPath));

    const at = AlineTransforms.unhangRange(editor, { at: editor.selection, select: false });
    return Range.isCollapsed(at) ? [] : [at];
  },
};

export default capitalizationQueries;
